// src/core/Leaderboard.js
// Convenience wrapper — this is what games import

import LeaderboardUI from './LeaderboardUI.js';
import PlayerIdentity from './PlayerIdentity.js';
import LeaderboardClient from './LeaderboardClient.js';

class Leaderboard {
    constructor(gameId) {
        this.gameId = gameId;
        this.ui = new LeaderboardUI();
    }

    /**
     * Call this when the game ends.
     * Submits the score and shows the leaderboard overlay.
     * @param {number} score - Final score
     * @param {function} [onPlayAgain] - Optional callback when "Play Again" is clicked
     */
    async mount() {
        await this.ui.mount(this.gameId);
    }

    async submitAndShow(score, onPlayAgain) {
        await this.ui.show(this.gameId, score, onPlayAgain);
    }

    /**
     * Just submit a score without showing UI.
     */
    async submit(score) {
        const name = PlayerIdentity.getName() || 'Anonymous';
        return LeaderboardClient.submit(this.gameId, name, score);
    }

    hide() {
        this.ui.hide();
    }
}

export { Leaderboard, PlayerIdentity, LeaderboardClient };
export default Leaderboard;
